<template>
  <div class="lead-form__container">
    <h3 class="lead-form__title"> Cadastre-se </h3>

    <div class="formLineBox formLineBox--02 lead-form__input-field">
      <fieldset class="formLine" :class="{ active: iptNome, error: $v.iptNome.$error, focus: focus.iptNome }">
        <div class="inputBox">
          <label for="iptNome">Nome *</label>
          <input
            type="text"
            name="iptNome"
            id="iptNome"
            v-model="iptNome"
            @focus="iptFocus('iptNome', $event)"
            @blur="iptBlur('iptNome', $event)"
            data-cy="lead-input-name"
          >
          <p class="errorText">{{ errors.iptNome }}</p>
        </div>
      </fieldset>
    </div>

    <div class="formLineBox formLineBox--02 lead-form__input-field">
      <fieldset class="formLine" :class="{ active: iptEmail, error: $v.iptEmail.$error, focus: focus.iptEmail }">
        <div class="inputBox">
          <label for="iptEmail">E-mail *</label>
          <input
            type="text"
            name="iptEmail"
            id="iptEmail"
            maxlength="50"
            v-model="iptEmail"
            @focus="iptFocus('iptEmail', $event)"
            @blur="iptBlur('iptEmail', $event)"
            data-cy="lead-input-email"
          >
          <p class="errorText" v-html="errors.iptEmail"></p>
        </div>
      </fieldset>
    </div>

    <div class="lead-form__actions">
      <button
        name="Avançar formulário"
        type="submit"
        class="button"
        :class="iptNome && iptEmail ? 'button--primary' : 'button--disabled'"
        :disabled="disableButton"
        @click="submit"
        data-cy="lead-button-register"
      >
        Cadastrar
      </button>
    </div>

    <!-- error modal -->
    <transition name="fade">
      <modal-base
        v-if="$parent.showModal"
        title='Atenção!'
        class="lead-form__error-modal"
      >
        <template v-slot:close-icon>
          <svg @click.prevent='$parent.showModal = false' class='modal__close-icon'>
            <use xlink:href='/images/svg-symbols.svg#close' />
          </svg>
        </template>
        <template v-slot:content>
          <p style="text-align: center !important">
            Ops! Ocorreu um erro no seu cadastro. <br>
            Por favor, verifique suas informações.
          </p>
        </template>
        <template v-slot:footer>
          <button class="button button--primary" @click.prevent="$parent.showModal = false">
            Tentar novamente
          </button>
        </template>
      </modal-base>
    </transition>

  </div>


</template>

<script>
  import { required, minLength, maxLength, email, sameAs, helpers } from 'vuelidate/lib/validators';
  // custom alpha validation
  const alpha = helpers.regex('alpha', /^([A-zÁ-ú]+\s*)*$/)

  import AwesomeMask from 'awesome-mask';

  import ModalBase from "commons/js/components/atoms/ModalBase.vue";

  import {scrollToTop} from 'commons/js/utils/scroll.js';

  import name from "commons/js/validators/name";

  export default {
    components: {
      ModalBase
    },

    data() {
      return {
        disableButton: false,
        iptNome: '',
        iptEmail: '',
        errorMessages: {
          required: "Campo obrigatório! Não esqueça de preenchê-lo.",
          name: "Use apenas letras, sem caracteres especiais ou números",
          minLength: "Dado inválido! Verifique sua resposta.",
          maxLength: "Dado inválido! Verifique sua resposta.",
          email: "Endereço de e-mail inválido! Verifique sua resposta.",
          sameAsEmail: "Endereço de e-mail inválido! Verifique sua resposta.",
          isUnique: "Este __field__ já está cadastrado ou é inválido. Gostaria de <a href='/login'>fazer login</a>?"
        },

        errors: {
          iptNome: '',
          iptEmail: '',
        },

        focus: {
          iptNome: false,
          iptEmail: false,
        }
      }
    },

    directives: {
      'mask': AwesomeMask
    },

    created() {
      if (this.$parent.firstname) {
        this.iptNome = this.$parent.firstname;
      }
      if (this.$parent.email) {
        this.iptEmail = this.$parent.email;
      }
    },

    mounted() {
      scrollToTop();
      setTimeout(this.$v.$reset, 0);
      setTimeout(() => {
        this.$el.querySelector(this.iptNome ? '#iptCPF' : '#iptNome').focus();
      }, 250);
    },

    watch: {
      iptEmail(value) {
        this.iptEmail = this.removeAccents(value);
      },
      iptConfirmaEmail(value) {
        this.iptConfirmaEmail = this.removeAccents(value);
      }
    },

    methods: {
      removeAccents(value) {
        let r = value.toLowerCase();
          r = r.replace(new RegExp(/[àáâãäå]/g),"a");
          r = r.replace(new RegExp(/æ/g),"ae");
          r = r.replace(new RegExp(/ç/g),"c");
          r = r.replace(new RegExp(/[èéêë]/g),"e");
          r = r.replace(new RegExp(/[ìíîï]/g),"i");
          r = r.replace(new RegExp(/ñ/g),"n");
          r = r.replace(new RegExp(/[òóôõö]/g),"o");
          r = r.replace(new RegExp(/œ/g),"oe");
          r = r.replace(new RegExp(/[ùúûü]/g),"u");
          r = r.replace(new RegExp(/[ýÿ]/g),"y");
          r = r.replace(new RegExp(/[~^´'!]/g),"");
          r = r.replace(new RegExp(/\s+/g),"");
        return r;
      },
      iptFocus(ipt) {
        this.focus[ipt] = true;
      },
      iptBlur(ipt) {
        this.focus[ipt] = false;
        this.$v[ipt].$touch();
        this.updateErrorMessage(ipt);
      },
      updateErrorMessage(key) {
        let errorTypes = Object.keys(this.errorMessages);
        for (let i = 0; i < errorTypes.length; i++) {
          let errorType = errorTypes[i];
          if (this.$v[key].hasOwnProperty(errorType) && !this.$v[key][errorType]) {
            this.errors[key] = '';
            if (this.errorMessages.hasOwnProperty(errorType)) {
              this.errors[key] = String(this.errorMessages[errorType])
                .replace(/__field__/, String(key).replace(/^ipt/, '').replace(/Change$/, ''));
            }
            break;
          }
        }
      },
      registerLead() {
        this.$parent.loading = true;

        let data = {
          name: String(this.iptNome).trim(),
          email: String(this.iptEmail).trim(),
          reference: 'new_register_screen'
        };

        Object.keys(data).forEach((key) => {
          if (!data[key]) delete data[key];
        });

        axios.post('/api/v2/leads', data).then((response) => {
          if (response.data) {
            this.$parent.id = response.data.id;
          }
        }).catch(() => {
          this.$parent.showModal = false;
        }).finally(() => {
          this.$emit('getRegistredLead', data);
          this.$parent.loading = false;
          this.disableButton = false;
          this.$parent.next();
        });
      },

      async $validate(v = this.$v) {
        v.$touch();

        await this.$nextTick();

        return new Promise((resolve) => {
          const unwatch = this.$watch(() => v.$pending,
          (isPending) => {
            if (!isPending) {
              resolve(!v.$invalid);
              if (unwatch) {
                unwatch();
              }
            }
          },
          {
            immediate: true
          });
        });
      },

      async submit() {
        if(this.disableButton) {
          return;
        }

        scrollToTop();

        await this.$validate();

        if (this.$v.$invalid) {
          let errorTypes = Object.keys(this.errorMessages);
          Object.keys(this.$v.$params).forEach((e) => {
            for (let i = 0; i < errorTypes.length; i++) {
              let errorType = errorTypes[i];
              if (this.$v[e].hasOwnProperty(errorType) && !this.$v[e][errorType]) {
                this.errors[e] = '';
                if (this.errorMessages.hasOwnProperty(errorType)) {
                  this.errors[e] = String(this.errorMessages[errorType])
                    .replace(/__field__/, String(e).replace(/^ipt/, '').replace(/Change$/, ''));
                }
                break;
              }
            }
          });
          return;
        }

        this.disableButton = true;
        this.registerLead();
      },

      isValidEmail(value) {
        const isValidEmail = email(value);
        const hasPlusSign = value.includes('+');

        if(!isValidEmail || hasPlusSign) {
          return false;
        }

        return true;
      }
    },

    validations: {
      iptNome: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(64),
        name
      },
      iptEmail: {
        required,

        email: function(value) {
          return this.isValidEmail(value);
        },

        isUnique(value) {
          if (!value) {
            return true;
          }

          if(!this.isValidEmail(value)) {
            return false;
          }

          return new Promise((resolve) => {
            axios.get('/api/v2/validate/email/' + value).then((response) => {
              resolve(response.data);
            }).catch((error) => {
              resolve(error.response.data || false);
            });
          });
        }
      },

    }
  }
</script>
